module.exports = "/_next/static/images/MakeInformedDecisions@2x-5c3b93964981bb26c4b569e94b45bba3.webp";